// extracted by mini-css-extract-plugin
export var container = "_jn-0";
export var dotAnimation = "_jn-2";
export var dotsLoading = "_jn-1";